import React from 'react';

import ContentTemplate from '../../components/ContentTemplate';
import ZPALayout from '../../components/ZPALayout/ZPALayout';
import {
    buildPrimaryPostPage,
    LayoutComponentProps,
} from '../../util/buildPrimaryPostPage';

const PremierAgentLayout: React.FC<LayoutComponentProps> = (props) => {
    const submenu = props.submenu as {
        items: Array<{
            id: string;
            title: { rendered: string };
            url: string;
            parent: number;
        }>;
        meta: {
            title: string;
            url: string;
            search: string;
        };
    };

    return (
        <ZPALayout
            head={props.head}
            preview={props.preview}
            submenu={submenu}
            header={props.header}
        >
            {props.children}
        </ZPALayout>
    );
};

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'ZPA',
        basePath: '/premier-agent',
        LayoutComponent: PremierAgentLayout,
        hasStickyNav: true,
        ContentComponent: ContentTemplate,
        contentType: 'B2B',
        knotchAccountId: process.env.NEXT_PUBLIC_KNOTCH_PA_LAYOUT_ACCOUNT_ID,
        menuPropName: 'submenu',
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
